export default {
  alternativeFundNumber: 'מספר קרן אלטרנטיבית',
  company: 'חברה מנהלת',
  branch: 'מוצר',
  accordType: 'סוג עמלה',
  edit: 'ערוך קרן אלטרנטיבית',
  agentCommission: 'עמלת סוכן %',
  employeeAgentCommission: 'עמלת עובד %',
  addAlternativeFund: 'הוסף קרן אלטרנטיבית',
  alternativeFundName: 'שם קרן',
  alternativeFundType: 'סוג קרן אלטרנטיבית',
  uid: 'מספר מזהה',
  comments: 'הערות',
  title: 'צפייה בקרנות אלטרנטיביות של הסוכן {1}',
  headers: {
    alternativeFunds: 'קרנות אלטרנטיביות',
  },
};
